/**
 * Created by root on 7/28/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var TableViewController = require('web-agent-framework/TableViewController');

    var Base = BaseFilterViewController;
    var FilterMultiSelectListViewController = Base.extend({
        ControllerName: 'FilterMultiSelectListViewController',
        LPViewMap: {
            listViewContainer: '.lpview_listview_container',
            filterArea: '.lpview_filterArea'
        },
        LPClassesMap: {},
        LPTemplatesFiles: {
            listItem: 'LP_filter_multi_select_listview_item.html'
        },

        initialize: function (constructorData) {
            this.titleText = constructorData.title;
            this.filterName = constructorData.filterName;
            this.filterTextSuffix = constructorData.filterTextSuffix;
            this.filterTitle = constructorData.filterTitle || '';
            this.disabledOption = constructorData.disabledOption || '';
            this.afterTitle = constructorData.afterTitle;
            this.searchFilterEventCallback = constructorData.searchFilterEventCallback;
            this.alphaOption = constructorData.alphaOption;
            this.items = lpUtils.cloneObject(constructorData.items);

            if (constructorData.defaultFilter) {
                this.filterResetData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterData = lpUtils.cloneObject(constructorData.defaultFilter);
            }

            this.initializeView();
        },
        events: function () {
        },
        render: function () {
            this.onShow();
        }
    });

    FilterMultiSelectListViewController.prototype.initializeView = function () {
        var tableTemplate = require('web-agent-templates/LP_filter_multi_select_listview.html');
        // var tableTemplate = lpUtils.loadResource('web-agent-templates/LP_filter_multi_select_listview.html');
        var textInjection = {
            title: this.titleText,
            afterTitle: this.afterTitle
        };
        tableTemplate = this.injectTextDefaults(tableTemplate, textInjection);
        this.createView({template: tableTemplate, target: this.LPViewMap.filterArea});

        //init according to data
        this.initializeTableView();
    };

    FilterMultiSelectListViewController.prototype.initializeTableView = function () {
        var self = this;
        var dataRenderer = {
            numberOfSections: function () {
                return 1;
            },
            numberOfRowsInSection: function (data) {
                return data.length;
            },
            dataForSection: function () {
                return;
            },
            dataForRowInSection: function (data, rowIndex) {
                var rowData = data[rowIndex];
                var value = {text: "", rowData: rowData, id: rowIndex};

                value.text = rowData.text;
                value.icon = rowData.icon;
                value.name = rowData.id;
                value.disabled = this.isDisabled.call(this, rowData.id) ? 'disabled' : '';
                value.checked = this.isSelected.call(this, rowData.id) ? 'checked' : '';
                value.separator = this.isSeparator.call(this, rowData.id) ? 'separator' : '';
                return value;
            },
            filterRow: function (data, filterText) {
                return false;
            },
            getPropertiesForHighlight: function () {
                return {text: true};
            }
        };

        // Creating the Table.
        this.listViewVC = new TableViewController({
            ControllerName: "TableViewController(FilterMultiSelectListViewController)",
            context: this,
            rowTemplateFile: this.LPTemplatesFiles.listItem,
            noDataTemplate: this.LPTemplatesFiles.listItem,
            modelData: this.items,
            dataRenderer: dataRenderer,
            modelController: lpTag.WebAgent.AppMediator,
            lineClicked: onLineClicked,
            supportKeysNavigation: true
        });
        this.addViewController({viewController: this.listViewVC, target: this.LPViewMap.listViewContainer});

        function onLineClicked(data) {
            self.toggleSelectedValue(data.rowData.id);
            self.updateFilterUI();
            self.setFocus();
        }
    };

    FilterMultiSelectListViewController.prototype.toggleSelectedValue = function (itemId) {
        if (this.isDisabled(itemId)) {
            return;
        }

        var items = this.getItemsArray();
        if (this.isSelected(itemId)) {
            var idx = items.indexOf(itemId);
            items.splice(idx, 1);
        }
        else {
            items.push(itemId);
        }

        //if the item is an alpha option and it's an enabling toggle - remove the rest from the list
        if (items.indexOf(itemId) >= 0 && itemId === this.alphaOption) {
            this.filterUIData.selectedItems = this.alphaOption;
        } else {
            // add the new item to the list
            this.filterUIData.selectedItems = items.join(',');
        }
    };

    FilterMultiSelectListViewController.prototype.isSelected = function (itemId) {
        var items = this.getItemsArray();
        for (var i = 0; i < items.length; i++) {
            if (itemId === items[i]) {
                return true;
            }
        }
        return false;
    };

    FilterMultiSelectListViewController.prototype.isSeparator = function (itemId) {
        var items = this.items;
        for (var i = 0; i < items.length; i++) {
            if (itemId === items[i].id && itemId === 'separator') {
                return true;
            }
        }
        return false;
    };

    //return true or false according to whether the option should be disabled, according to the filter data
    FilterMultiSelectListViewController.prototype.isDisabled = function (itemId) {
        var items = this.items;
        var disabledOptions = this.disabledOption.split(',');
        for (var i = 0; i < items.length; i++) {
            if ((disabledOptions.indexOf(itemId) >= 0) && itemId === items[i].id) {
                return true;
            } else if (itemId !== this.alphaOption && this.isAlphaOptionSelected()) { //alphaOption is selected and this is not it
                return true;
            }
        }
        return false;
    };

    FilterMultiSelectListViewController.prototype.isAlphaOptionSelected = function () {
        //check if this filter has a chatId option. If it does, check if it's in the selected list for UI and return the result
        var items = this.items;
        for (var i = 0; i < items.length; i++) {
            if (items[i].id === this.alphaOption && this.isSelected(items[i].id)) {
                return true;
            }
        }
        return false;
    };

    FilterMultiSelectListViewController.prototype.updateFilterUI = function () {
        this.listViewVC.modelChanged();
    };

    FilterMultiSelectListViewController.prototype.getItemsArray = function () {
        if (this.filterUIData && this.filterUIData.selectedItems) {
            return this.filterUIData.selectedItems.split(',');
        }
        return [];
    };

    FilterMultiSelectListViewController.prototype.isEmptyValue = function (dataObj) {
        if (dataObj && typeof dataObj.selectedItems !== 'undefined') {
            return (dataObj.selectedItems === "");
        }
        return true;
    };


    return FilterMultiSelectListViewController;

});
